<template>
  <html>
    <header>
      <Head />
    </header>
    <body class=".responsive bg--white">
      <div class="container align--center">
        <div class="grid-column">
          <h1>quiz summary</h1>
        </div>

        <div class="grid-column">
          <h3 class="mb2"><span class="text--green">{{correctNumberOfQuestions}}</span> correct</h3>
          <h3 class="mb2"><span class="text--red">{{incorrectNumberOfQuestions}}</span> incorrect</h3>
        </div>

        <div class="grid-row">
          <div class="grid-column mt3 mb2">
            <button class="btn btn--primary" :disabled="incorrectNumberOfQuestions === 0"><router-link to="/review">review quiz</router-link></button>
          </div>

          <div class="grid-column mt3 mb2">
            <button class="btn btn--primary"><router-link to="/quiz">new quiz</router-link></button>
          </div>
        </div>

        <div class="grid-column">
          <h2 class="mb2">Download mobile app</h2>
          <span>
            <a :href="iosLink" class="link"><img class="download" src="../../static/ios.png" alt="Download on the App Store"></a>
          </span>
          <span>
            <a :href="androidLink" class="link"><img class="download" src="../../static/googleplay.png" alt="Download on Google Play"></a>
          </span>
        </div>
      </div>

      <div class="fixed left--0 bottom--0 right--0 bg--almost-white">
        <Foot />
      </div>
    </body>
  </html>
</template>

<script>
import Head from './Head';
import Foot from './Foot';
export default {
  name: 'result',
  components: { Head, Foot },

  computed: {
    correctNumberOfQuestions() {
      return this.$store.state.correctNumberOfQuestions
    },

    incorrectNumberOfQuestions() {
      return (this.$store.state.actualNumberOfQuestions - this.correctNumberOfQuestions)
    },

    androidLink() {
      return this.$store.state.androidLink
    },

    iosLink() {
      return this.$store.state.iosLink
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/scss/main.scss'
</style>



// WEBPACK FOOTER //
// src/components/Result.vue